import { useAuthenticatedAPI } from "@/api";
import { FORCE_ENABLE_CHAT } from "@/constants";
import { GetFeatureFlagClientAppEnum, GetFeatureFlagFeatureFlagEnum } from "@norma-bi/bi-api";
import { useQuery } from "@tanstack/react-query";

export function useGetChatFeatureFlag() {
  const api = useAuthenticatedAPI();
  return useQuery({
    queryKey: ["getChatFeatureFlag"],
    queryFn: () => {
      if (FORCE_ENABLE_CHAT) {
        return { enabled: true };
      }
      return api.getFeatureFlag({
        feature_flag: GetFeatureFlagFeatureFlagEnum.chat,
        client_app: GetFeatureFlagClientAppEnum.web_app,
      });
    },
    staleTime: 1000 * 60 * 60 * 12, // 12 hours
  });
}
